import React from 'react';

const SwitchComponent = ({
     leftTitle = 'Register',
     rightTitle = 'Sign In',
     leftIsActive = true,
     rightIsActive = false,
     leftAction,
     rightAction
}) => {
    const keyVal = `${leftTitle?.toLowerCase()?.replace(' ', '-')}_${rightTitle?.toLowerCase()?.replace(' ', '_')}`;

    return (
        <div className="switch" key={`switch_component_${keyVal}`}>
            <div
                key={`left_switch_${keyVal}`}
                onClick={leftAction}
                className={`item_switch ${leftIsActive ? 'isActive isActiveLeft' : ''}`}>
                {leftTitle}
            </div>
            <div
                key={`right_switch_${keyVal}`}
                onClick={rightAction}
                className={`item_switch ${rightIsActive ? 'isActive isActiveRight' : ''}`}>
                {rightTitle}
            </div>
        </div>
    );
}

export default SwitchComponent
